/*
 * Copyright (c) 2016 Mailtech.cn, Ltd. All Rights Reserved.
 */

/* global WsStore */

/**
 * 一次性模块，即只有一次调用，可以把所有用到的变量保存到根作用域中
 * */

;define(
    function (require) {
        var $ = require('jquery');
        var Handlebars = require('./hbshelper');
        var io = require('socket.io-client');
        var PollingStore = require('common/pollstore');

        require('common/wsstore');

        var hideClass = 'f-dn';
        var disableClass = 'disabled';

        var authData = null;

        var $authWrap = null;
        var $loginForm = null;

        var $authBody = null;
        var $authFooter = null;
        var $btnAuthConfirm = null;
        var $btnSubmit = null;

        var toggleAuthWrap = function(showAuth) {
            showAuth = typeof showAuth === 'boolean' ? showAuth : false;

            if (showAuth) {
                $loginForm.addClass(hideClass);
                $authWrap.removeClass(hideClass);
            } else {
                $authWrap.addClass(hideClass);
                $loginForm.removeClass(hideClass);
            }
        };

        var focusInput = function($input, enterCb) {
            if (!$input || !$input.length) return false;

            enterCb = $.isFunction(enterCb) ? enterCb : $.noop;

            $input
                    .off('focus')
                    .on('focus', function() {
                        $(this).off('keyup.enter').on('keyup.enter', function(e) {
                            if (e.keyCode === 13) {
                                enterCb(e);
                            }
                        });
                    })
                    .off('blur')
                    .on('blur', function() {
                        $(this).off('keyup.enter');
                    });

            setTimeout(function() {
                $input.trigger('focus');
            }, 200);
        };

        var checkCode = function(errorMsg) {
            var $code = $authBody.find('.j-code');
            var $wrapper = $authBody.find('.j-wrap');
            var $error = $wrapper.find('.j-error');
            var codeValue = $.trim($code.val()).toUpperCase();
            if (!codeValue.length) {
                // 验证码不能为空
                if ($error.length > 0) {
                    $error.remove();
                }

                $wrapper.append(Handlebars.compile($('#errorMsgTpl').html())({
                    errorMsg: errorMsg
                }));

                $code.focus();
                return '';
            } else {
                return codeValue;
            }
        };

        var triggerSubmit = function() {
            if (!$btnAuthConfirm || !$btnAuthConfirm.length) return false;
            $btnAuthConfirm.trigger('click');
        };

        var SmsVerifyFactory = function(options) {
            this.authData = options.authData;
            this._render();
            this._initEvents();
        };

        SmsVerifyFactory.prototype = {
            constructor: SmsVerifyFactory,
            submit: function() {
                var codeValue = checkCode(this.authData.emptySMSCodeMsg);

                if (codeValue.length > 0) {
                    $loginForm.find('#verifyCellCode').val(codeValue);
                    $btnSubmit.trigger('click');
                }
            },
            cancel: function() {
                this._offEvents();
            },
            _render: function() {
                $authBody.html(Handlebars.compile($('#smsVerifyTpl').html())(this.authData));
                focusInput($authBody.find('.j-code'), triggerSubmit);
            },
            _initEvents: function() {
                $authBody.off('click', '.j-send').on('click', '.j-send', $.proxy(this._handleSendCode, this));
            },
            _offEvents: function() {
                $authBody.off('click', '.j-send');
            },
            _handleSendCode: function() {
                $loginForm.find('#resendCellCode').prop('disabled', false);
                $btnSubmit.trigger('click');
            }
        };

        var KeyVerifyFactory = function(options) {
            this.authData = options.authData;
            this._render();
        };

        KeyVerifyFactory.prototype = {
            constructor: KeyVerifyFactory,
            submit: function() {
                var codeValue = checkCode(this.authData.emptyDynamicPasswordMsg);

                if (codeValue.length > 0) {
                    $loginForm.find('.j-form-dynamicPwd').val(codeValue);
                    $btnSubmit.trigger('click');
                }
            },
            cancel: function() {
                // do nothing
            },
            _render: function() {
                $authBody.html(Handlebars.compile($('#dynamic1VerifyTpl').html())(this.authData));
                focusInput($authBody.find('.j-code'), triggerSubmit);
            }
        };

        var OtpVerifyFactory = function(options) {
            this.authData = options.authData;
            this.authType = this.authEnums.PUSH;

            this.$verifyWrap = null;
            this.observer = null;

            this._render();
        };

        OtpVerifyFactory.prototype = {
            constructor: OtpVerifyFactory,
            authEnums: {
                PUSH: 1,
                CODE: 2
            },
            submit: function() {
                var codeValue = '';

                if (this.authType === this.authEnums.PUSH) {
                    this._doSubmit(codeValue);
                } else {
                    codeValue = checkCode(this.authData.emptyAuthCodeMsg);

                    if (codeValue.length > 0) {
                        this._doSubmit(codeValue);
                    }
                }
            },
            cancel: function() {
                this._unSubscribe();
            },
            _unSubscribe: function() {
                this.observer != null && this.observer.unSubscribe();
            },
            _doSubmit: function(verifyCode) {
                this.observer != null && this.observer.unSubscribe();

                $loginForm.find('.j-form-dynamicPwd').val(verifyCode);
                $btnSubmit.trigger('click');
            },
            _render: function() {
                $authBody.html(Handlebars.compile($('#dynamic2VerifyWrapTpl').html())());
                this.$verifyWrap = $authBody.find('.j-dynamic2-verify');

                if (this.authType === this.authEnums.CODE) {
                    this._renderCode();
                } else {
                    this._renderPush();
                }

                this._prepareValidate();
            },
            _renderPush: function() {
                var self = this;
                this.authType = this.authEnums.PUSH;

                $btnAuthConfirm.addClass(disableClass).addClass(hideClass);

                this.$verifyWrap.html(Handlebars.compile($('#dynamic2PushVerifyTpl').html())(this.authData));

                this.$verifyWrap.off('click', '.j-toggle').on('click', '.j-toggle', function() {
                    self._renderCode();
                });
            },
            _renderCode: function() {
                var self = this;
                this.authType = this.authEnums.code;

                $btnAuthConfirm.removeClass(disableClass).removeClass(hideClass);

                this.$verifyWrap.html(Handlebars.compile($('#dynamic2CodeVerifyTpl').html())(this.authData));
                focusInput($authBody.find('.j-code'), triggerSubmit);

                this.$verifyWrap.off('click', '.j-toggle').on('click', '.j-toggle', function() {
                    self._renderPush();
                });
            },
            _prepareValidate: function() {
                var self = this;
                var authData = this.authData;

                $.ajax({
                    type: 'POST',
                    url: '/@context.name@/s/json?func=user:triggerSecondAuth',
                    data: '{"trans": "login", "tempSid": "' + authData.tempSession + '"}',
                    headers: {
                        Accept: 'text/x-json'
                    },
                    contentType: 'text/x-json'
                }).done(function(data) {
                    if (data && data.code && data.code !== 'S_OK') {
                        // todo: 提示错误信息
                    } else {
                        self._subscribeValidate();
                    }
                }).fail(function() {
                    // todo: 提示错误信息
                });
            },
            _subscribeValidate: function() {
                var self = this;
                var topic = WsStore.topics.OTP_AUTH;
                var authData = this.authData;

                if (('WebSocket' in window)) {
                    topic = topic.replace('$uid$', authData.uid);
                    topic = topic.replace('$tempsid$', authData.tempSession);

                    WsStore.subscribe(topic, function(msgData) {
                        var trans = msgData.payload.trans;

                        if (trans !== 'login') {
                            alert('invalid trans');
                            return false;
                        }

                        WsStore.unSubscribe();

                        $.ajax({
                            type: 'POST',
                            url: '/@context.name@/s/json?func=user:querySecondAuthValidateStage',
                            data: '{"trans": "login", "tempSid": "' + authData.tempSession + '"}',
                            headers: {
                                Accept: 'text/x-json'
                            },
                            contentType: 'text/x-json'
                        }).done(function(data) {
                            self._unSubscribe();

                            var code = data && data.code;
                            if (code === 'S_OK') {
                                if (data['var'] && data['var']['stage'] === 'VALIDATED') {
                                    $btnAuthConfirm.removeClass(disableClass).removeClass(hideClass);
                                    $btnAuthConfirm.trigger('click');
                                }
                                return;
                            }

                            // 若otp 推送的session 过期，
                            // 鉴于现在交互设计中，不需要重新发送推送请求，所以，
                            // 在不刷新的情况下，则强制使用手动输入验证码授权登录
                            if (code === 'FA_INVALID_TEMP_SESSION') {
                                authData.forceCode = true;
                                self._renderCode();
                            }
                            // todo: 提示其他类型错误信息
                        }).fail(function() {
                            self._unSubscribe();
                            // todo: 提示错误信息
                        });
                    }, {
                        authMeta: {
                            clientId : 'webmail:' + authData.tempSession,
                            sid      : authData.tempSession,
                            TmpSes   : 1
                        },
                        io: io,
                        host: self.authData.host
                    });
                    this.observer = WsStore;
                } else {
                    this.observer = new PollingStore({
                        topic: '/@context.name@/s/json?func=user:querySecondAuthValidateStage',
                        data: '{"trans": "login", "tempSid": "' + authData.tempSession + '"}',
                        successCallback: function(result) {
                            if (result.stage && result.stage === 'VALIDATED') {
                                self._unSubscribe();
                                $btnAuthConfirm.removeClass(disableClass).removeClass(hideClass);
                                $btnAuthConfirm.trigger('click');
                            }
                        },
                        errorCallback: function(data) {
                            if (data.code === 'FA_INVALID_SESSION' || data.code === 'FA_INVALID_TEMP_SESSION') {
                                self._unSubscribe();
                            }
                        }
                    }).subscribe();
                }
            }
        };


        var initVerify = function(options) {
            var verifyIns;
            var backObserver;

            if ($.isEmptyObject(options)) {
                return false;
            }

            backObserver = options.backObserver || $.noop;

            authData = options.authData;

            $authWrap = options.$authWrap;
            $loginForm = options.$loginForm;

            $authBody = $authWrap.find('.j-auth-body');
            $authFooter = $authWrap.find('.j-auth-footer');
            $btnAuthConfirm = $authFooter.find('.j-confirm');

            $btnSubmit = $loginForm.find('.j-submit');

            if (authData.dynamic1) {
                verifyIns = new KeyVerifyFactory({
                    authData: authData
                });
            } else if (authData.dynamic2) {
                verifyIns = new OtpVerifyFactory({
                    authData: authData
                });
            } else if (authData.sms) {
                verifyIns = new SmsVerifyFactory({
                    authData: authData
                });
            }

            toggleAuthWrap(true);

            $authFooter.off('click', '.j-confirm').on('click', '.j-confirm', function() {
                var vcCode;

                if (options.authData.needVerifyCode) {
                    vcCode = $.trim($authWrap.find('.j-vc-verify-code').val());

                    if (!vcCode.length) {
                        // todo: 使用轻量点的dialog 组件
                        alert(options.authData.emptyVerifyCodeMsg);
                        return;
                    }

                    $loginForm.find('.j-vc-verify-code').val(vcCode.toUpperCase());
                }

                var $authorizeDevice = $authFooter.find('.j-authorize-device');
                var isNeedToAuthorizeDevice;
                if ($authorizeDevice.length) {
                    isNeedToAuthorizeDevice = $authorizeDevice.prop('checked');
                    if (isNeedToAuthorizeDevice) $loginForm.find('.j-authorizeDevice').val(true);
                }
                verifyIns.submit();
            });

            $authFooter.off('click', '.j-back').on('click', '.j-back', function(e) {
                if (backObserver() === false) return;

                verifyIns.cancel();
                toggleAuthWrap(false);
            });

            $authFooter.off('click', '.j-back-to-referrer').on('click', '.j-back-to-referrer', function() {
                verifyIns.cancel();

                var $referrer = $loginForm.find('.j-startReferrer');
                if ($referrer.length && $referrer.val().length) {
                    location.replace($referrer.val());
                } else {
                    if (backObserver() === false) return;
                    toggleAuthWrap(false);
                }
            });
        };

        return {
            initVerify: initVerify
        };
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./web.modules/coremail.framework/src/common/assets/index_cmxt50/js/twofactorverify.js
 ** module id = 157
 ** module chunks = 15
 **/